import { Command } from '@/app/tracking/api';

export interface AnswerQuestionTrackingCommandPayload {
  question: AnswerQuestionDetails;
  meta: QuestionMeta;
  role: 'inline' | 'practice' | 'exam';
}

export interface AnswerQuestionDetails {
  id: string;
  response: string;
  score: number;
  timestamp: Date;
  durationSeconds: number;
}

interface QuestionMeta {
  type: string;
  title: string;
}

export const AnswerQuestionTrackingCommandName = 'answer-question' as const;
export type AnswerQuestionTrackingCommand =
      Command<typeof AnswerQuestionTrackingCommandName, AnswerQuestionTrackingCommandPayload>;
